import { Base } from "@studiometa/js-toolkit";

export default class NativeShare extends Base {
  static config = {
    name: 'NativeShare',
    options: {
      title: String,
      text: String,
      url: String,
    },
  };

  /**
   * Click on share button
   */
  async onClick() {
    try {
      await navigator.share({
        title: this.$options.title,
        text: this.$options.text,
        url: this.$options.url ?? window.location.href,
      });
    } catch (err) {
      this.$log(`Error: ${err}`);
    }
  }
}
